// tiny temp auth until your backend is wired
const KEY = 'ohit_auth';
const SESSION_START_KEY = 'ohit_session_start';

export function isAuthed(): boolean {
  try {
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function markAuthed() {
  try {
    sessionStorage.setItem(KEY, '1');
    sessionStorage.setItem(SESSION_START_KEY, Date.now().toString());
  } catch {}
}

export function clearAuth() {
  try {
    sessionStorage.removeItem(KEY);
    sessionStorage.removeItem(SESSION_START_KEY);
  } catch {}
}

export function getSessionStartTime(): number | null {
  try {
    const startTime = sessionStorage.getItem(SESSION_START_KEY);
    return startTime ? parseInt(startTime, 10) : null;
  } catch {
    return null;
  }
}
